import React from "react"
import { EMPTY_FAVORITE_BASE64 } from "@/constants"
import cartGray from "@/public/icons/cart-gray.svg"
import avatarIcon from "@/public/icons/new-avatar.svg"
import utilityStyles from "@/components/Shared/UtilityWidgets/v1/UtilityWidgets.module.scss"

const UtilityWidgetsLoader = () => {
  return (
    <div className={utilityStyles.utilityWidgetsWrapper}>
    <div className="utilityWidgetsWrapper">
    <div role="list" className="utility-widgets">
      <div role="listitem" className="search-widget">
        <div>
          <button
            className="search-button bg-transparent"
            role="button"
          >
            <span className="search-text">Search</span>
            <span className="search-icon">
              <img
                role="presentation"
                src="data:image/svg+xml;base64,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"
                alt="search-icon"
              />
            </span>
          </button>
        </div>
      </div>
      <div role="listitem" className="auth-widget-mobile">
        <button
          aria-label="sign-in"
          className="bg-transparent auth-widget"
        >
          <img
            className="auth-nav__sign-in-avatar"
            aria-hidden="true"
            alt="auth-nav"
            src={avatarIcon.src}
          />
        </button>
      </div>
      <div role="listitem" className="wishlist-widget d-lg-none">
        <a
          aria-label="View your wishlist"
          href="/"
        >
          <img
            aria-hidden="true"
            alt="Wishlist"
            src={EMPTY_FAVORITE_BASE64}
          />
        </a>
      </div>
      <div role="listitem" className="cart-indicator-widget d-lg-none">
        <div className="cart-indicator false">
          <a
            href="/cart"
            role="link"
          >
            <img src={cartGray.src} alt="Cart" />
          </a>
        </div>
      </div>
    </div>
    </div>
    </div>
  )
}

export default UtilityWidgetsLoader
